<template>
  <div class="container content-block forgot-password mt-5">
    <h3>Wachtwoord vergeten</h3>
    <!--      <p>-->
    <!--        Wachtwoord vergeten? Geef hier je e-mailadres in en we sturen je een link waar je een nieuw wachtwoord kan-->
    <!--        instellen.-->
    <!--      </p>-->
    <div class="mt-3" v-if="mailSent">
      <p>
        Een e-mail werd gestuurd naar het opgegeven e-mailadres. Klik op de link in deze e-mail om je wachtwoord te
        wijzigen.
      </p>
      <router-link to="/login" class="btn btn-sandpiper btn-block">Aanmelden</router-link>
    </div>
    <form class="forgot-password-form" @submit.prevent="requestPasswordReset" v-else>
      <div class="form-group">
        <label for="email">E-mailadres</label>
        <input id="email" type="email" class="form-control" v-model="email" autocomplete="username">
      </div>
      <button class="btn btn-sandpiper btn-block" :class="[requestingPasswordReset ? 'disabled' : '']" type="submit"
              :disabled="requestingPasswordReset">
        Wachtwoord wijzigen
      </button>
    </form>
  </div>
</template>

<script>
import log from "@/utils/logger";
import { AuthApi } from "sandpiper_api";

export default {
  name: "ForgotPassword",
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      email: '',
      requestingPasswordReset: false,
      mailSent: false
    };
  },
  methods: {
    async requestPasswordReset()
    {
      try
      {
        log.info("Trying to activate account for user [%s] with activation code [%s]", this.userId, this.activationCode);

        this.requestingPasswordReset = true;
        await this.doApiRequest(() => new AuthApi().requestPasswordResetEmail(this.email));
      }
      catch (e)
      {
        this.activationSucceeded = false;
        // TODO - handle error, show correct message (but don't say if the error is 'user' does not exist, which should already be block by the server)
      }
      finally
      {
        this.requestingPasswordReset = false;
        // NOTE: don't let user know whether the email that he/she entered actually exists (for security reasons), just
        // say that an email has been sent IF the email address exists.
        this.mailSent = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-block
{
  padding: 25px;
}

.forgot-password
{
  max-width: 400px;

  h3
  {
    font-size: 20px;
    font-weight: bold;
  }

  label
  {
    font-weight: bold;
  }
}

.forgot-password-form
{
  margin-top: 20px;
}
</style>